import axios from "axios";
import router from "@/router";

const state = {
  currentAltCitiesPage: {
    content: null,
    custom_markup_head: null,
    custom_markup_body: null,
    custom_css: null,
    facilities: [],
    meta_breadcrumb_title: null,
    meta_description: null,
    meta_keywords: null,
    meta_menu_title: null,
    meta_title: null,
    name: null,
    page_header: null,
    published: false,
    slug: null,
    state: null
  },
  altCitiesPages: [],
  pagination: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ["meta_title"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    mustSort: false,
    multiSort: false,
    totalItems: 0,
    rowsPerPageOptions: [25, 50, 75, 100]
  }
};

const actions = {
  getAllAltCitiesPages: ({ commit, state }) => {
    const sortingOrder = state.pagination.sortDesc[0] ? "desc" : "asc";
    return axios.get(`/alt-cities`, {
      params: {
        page: state.pagination.page,
        per_page: state.pagination.itemsPerPage,
        sort_by: state.pagination.sortBy[0],
        sort_direction: sortingOrder
      }
    })
      .then((resp) => {
        commit("getAllAltCitiesPagesSuccess", resp.data);
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getAltCitiesPage: ({ commit }, id) => {
    return axios.get(`/alt-cities/${id}`)
      .then((resp) => {
        commit("setCurrentAltCitiesPageData", resp.data.alt_city_page);
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  createAltCitiesPage: ({ state, commit, dispatch }) => {
    return axios.post(`/alt-cities`, state.currentAltCitiesPage)
      .then((resp) => {
        commit("resetCurrentAltCitiesPage");
        dispatch("snackbar/successMessage", `Successfully created new alt city page`, { root: true });
        router.push("/alt-cities-pages");
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },

  updateAltCitiesPage: ({ state, dispatch }) => {
    return axios.patch(`/alt-cities/${state.currentAltCitiesPage.id}`, state.currentAltCitiesPage)
      .then((resp) => {
        dispatch("getAltCitiesPage", state.currentAltCitiesPage.id);
        dispatch("snackbar/successMessage", `Successfully updated alt city page`, { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },

  deleteAltCitiesPage: ({ dispatch }, id) => {
    return axios.delete(`/alt-cities/${id}`)
      .then((resp) => {
        dispatch("getAllAltCitiesPages");
        dispatch("snackbar/successMessage", `Successfully deleted alt city page`, { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  }
};

const mutations = {
  setAltCitiesPagination: (state, payload) => {
    state.pagination = payload;
  },

  getAllAltCitiesPagesSuccess: (state, altCitiesPages) => {
    state.altCitiesPages = altCitiesPages.data;
    state.pagination.totalItems = altCitiesPages.total;
  },

  setCurrentAltCitiesPageData: (state, altCitiesPage) => {
    state.currentAltCitiesPage = altCitiesPage;
  },

  resetCurrentAltCitiesPage: (state) => {
    state.currentAltCitiesPage = {
      content: null,
      custom_markup_head: null,
      custom_markup_body: null,
      custom_css: null,
      facilities: [],
      meta_breadcrumb_title: null,
      meta_description: null,
      meta_keywords: null,
      meta_menu_title: null,
      meta_title: null,
      name: null,
      page_header: null,
      published: false,
      slug: null,
      state: null
    };
  }
};

export default {
  state,
  actions,
  mutations
};
